import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ko',
  months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
  weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
  weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'A h:mm',
    lts: 'A h:mm:ss',
    L: 'YYYY. M. D.',
    LL: 'YYYY[년] M[월] D[일]',
    'LL-D': 'YYYY[년] M[월]',
    'LL-Y': 'M[월] D[일]',
    LLL: 'YYYY[년] M[월] D[일] HH:mm',
    'LLL-Y': 'M[월] D[일] HH:mm',
    LLLL: 'YYYY[년] M[월] D[일] dddd HH:mm',
    'LLLL-Y': 'M[월] D[일] dddd HH:mm',
    l: 'YYYY. M. D.',
    'l-Y': 'M. D.',
    ll: 'YYYY[년] M[월] D[일]',
    'll-Y': 'M[월] D[일]',
    lll: 'YYYY[년] M[월] D[일] A h:mm',
    'lll-Y': 'M[월] D[일] A h:mm',
    llll: 'YYYY[년] M[월] D[일] dddd A h:mm',
    'llll-Y': 'M[월] D[일] dddd A h:mm',
    'll-Y+w': 'MMM D일 (ddd)',
    'LT+to': 'HH:mm([GMT]Z)',
    'LLL+to': 'YYYY년 M월 D일 HH:mm([GMT]Z)',
  },
  meridiem: { am: '오전', pm: '오후', AM: '오전', PM: '오후' },
  past: {
    y: { other: '%s년 전' },
    M: { other: '%s개월 전' },
    w: { other: '%s주 전' },
    d: { other: '%s일 전' },
    h: { other: '%s시간 전' },
    m: { other: '%s분 전' },
    s: { other: '%s초 전' },
  },
  future: {
    y: { other: '%s년 후' },
    M: { other: '%s개월 후' },
    w: { other: '%s주 후' },
    d: { other: '%s일 후' },
    h: { other: '%s시간 후' },
    m: { other: '%s분 후' },
    s: { other: '%s초 후' },
  },
  abbr: {
    y: { other: '%s년' },
    M: { other: '%s개월' },
    w: { other: '%s주' },
    d: { other: '%s일' },
    h: { other: '%s시간' },
    m: { other: '%s분' },
    s: { other: '%s초' },
  },
  justNow: '방금',
  yesterday: '어제',
  today: '오늘',
  tomorrow: '내일',
  weekStart: 0,
};
const localeName: LocaleName = 'ko';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? '오전' : '오전';
    } else {
      return isLowerCase ? '오후' : '오후';
    }
  },
};
